import React, { useEffect, lazy } from 'react';
import { useCountdown } from './hooks/useCountdown';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { AgitationSection } from './components/AgitationSection';
import { MechanismSection } from './components/MechanismSection';
import { GabrielBio } from './components/GabrielBio';
import { Testimonials } from './components/Testimonials';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { LazySection } from './components/LazySection';
const Divider = () => <div className="h-px bg-gold/15 max-w-[200px] mx-auto" data-id="element-0" />;
export function App() {
  const {
    formattedTime,
    isExpired
  } = useCountdown(15);
  useEffect(() => {
    // Defer Meta Pixel initialization to not block initial render
    const timer = setTimeout(() => {
      initMetaPixel();
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-dark text-body font-sans selection:bg-gold/30 selection:text-body" data-id="element-1">
      <UrgencyBar formattedTime={formattedTime} isExpired={isExpired} data-id="element-2" />

      <main data-id="element-3">
        <HeroSection isExpired={isExpired} data-id="element-4" />
        <Divider data-id="element-5" />
        <HookSection data-id="element-6" />
        <Divider data-id="element-7" />
        <AgitationSection data-id="element-8" />
        <Divider data-id="element-9" />
        <MechanismSection data-id="element-10" />
        <Divider data-id="element-11" />
        <GabrielBio data-id="element-12" />
        <Divider data-id="element-13" />
        <Testimonials data-id="element-14" />
        <Divider data-id="element-15" />
        <OfferSection data-id="element-16" />
        <Divider data-id="element-17" />
        <PricingSection isExpired={isExpired} data-id="element-18" />
        <Divider data-id="element-19" />
        <FAQSection data-id="element-20" />
        <Divider data-id="element-21" />
        <GuaranteeSection data-id="element-22" />
        <Divider data-id="element-23" />
        <ClosingSection isExpired={isExpired} data-id="element-24" />
      </main>

      <Footer data-id="element-25" />
    </div>;
}